module.exports = __webpack_public_path__ + "static/sponsor-06-c09f67ed9568c1f59eddd3dc2747fac2.png";